module.exports = __webpack_public_path__ + "img/hombres.5ec9d90c.png";